export default class AnalyticGroup {
  constructor() {
    // config
    this.key = 'analytic'
    this.name = 'Analytic'
    this.description = ''
  }
}
